import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import React, { useEffect } from 'react';
import { AiFillEdit } from 'react-icons/ai';
import { useNavigate, useParams } from 'react-router';
import { useGrades } from '../grades/Grades';

const useStyles = makeStyles({
  table: {
    minWidth: 700,
    maxWidth: '100%',
  },
  TableContainer: {
    maxWidth: '70%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '22%',
  },
  input: {
    marginTop: '10px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
  },
  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '50px',
  },
});

export default function UpdateCourse() {
  const classes = useStyles();
  const [numericName, setNumericName] = React.useState('');
  const [alphaName, setAlphaName] = React.useState('');
  const { grades } = useGrades();
  const [grade, setGrade] = React.useState('');
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetch(`https://api.edicionesmilenio.com/api/courses/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data?.data) {
          setNumericName(data?.data?.numericName);
          setAlphaName(data?.data?.alphaName);
          setGrade(data?.data?.grade?._id);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleUpdate = async () => {
    try {
      if (numericName && alphaName) {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/courses/${id}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              numericName,
              alphaName,
              grade,
            }),
          }
        );
        let data = await response.json();
        if (data.success === true) {
          navigate('/admin/courses', { replace: true });
        } else {
          console.error(data.message);
          window.alert('Error al actualizar el curso, intente de nuevo');
        }
      } else {
        window.alert('Error al actualizar el curso, intente de nuevo');
      }
    } catch (err) {
      console.error(err);
      window.alert('Error al actualizar el curso, intente de nuevo');
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, mediante este formulario usted podrá actualizar
        los cursos de la plataforma.
      </p>
      <TextField
        className={classes.input}
        id="outlined-basic"
        label="Nombre numerico"
        variant="outlined"
        value={numericName || ''}
        onChange={(e) => setNumericName(e.target.value)}
      />
      <TextField
        className={classes.input}
        id="outlined-basic"
        label="Numero alfabetico"
        variant="outlined"
        value={alphaName || ''}
        onChange={(e) => setAlphaName(e.target.value)}
      />
      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="demo-simple-select-outlined-label">Grado:</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={grade || ''}
          onChange={(e) => setGrade(e.target.value)}
          label="Grado"
        >
          {grades.map((grade) => (
            <MenuItem value={grade._id}>{grade.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        onClick={() => {
          setNumericName('');
          setAlphaName('');
          setGrade('');
        }}
      >
        Limpiar
      </Button>
      <div className={classes.formButtonsContainer}>
        <Button onClick={handleUpdate} variant="contained">
          <AiFillEdit size={15} />
          Actualizar
        </Button>
      </div>
    </div>
  );
}
